import { render, staticRenderFns } from "./AccountQualificationDetailTable.vue?vue&type=template&id=413c8e39&"
import script from "./AccountQualificationDetailTable.vue?vue&type=script&lang=ts&"
export * from "./AccountQualificationDetailTable.vue?vue&type=script&lang=ts&"
import style0 from "./AccountQualificationDetailTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VProgressCircular})
